import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import {tableHideDetails} from "../../../../../@signals";

export default function PriceContent(
	{
		price,
		prevPrice,
		evolutionChange,
		evolutionDiff,
		currency = '',
		// Analyzers that always want the bare price say so instead of relying on the
		// shared details toggle, which any toolbar can flip.
		compact = false,
	}) {
	const priceColor = 'text.primary'
	const onlyPrice = compact || tableHideDetails.value
	const evolutionIcons = {
		increase: { color: "success.dark", icon: "arrow-up" },
		decrease: { color: "error.main", icon: "arrow-down" },
		equal: { icon: "equals" },
	}
	const PriceDisplay = ({ value, color }) => <Typography variant="subtitle1" color={color} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
		{!!value ? `${value}` : 'N/A'}
		{!currency && <IconSeeker icon="star" sx={{ color: "warning.main" }}/>}
	</Typography>


	return <Grid container>
		<Grid item xs={(!evolutionChange && !prevPrice || onlyPrice) ? 12 : 6} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
			<TooltipSeeker title="Current Price">
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<PriceDisplay value={price} color={priceColor}/>
				</Box>
			</TooltipSeeker>
		</Grid>
		{!onlyPrice && (
			<Grid item xs={6} sx={{ visibility: !evolutionChange ? 'hidden' : ''  }}>
				<TooltipSeeker title="Difference between current price and previous price" componentsProps={{ sx: { display: "flex" } }}>
					<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: .5 }}>
						<IconSeeker {...evolutionIcons[evolutionChange]} sx={{ mt: .2 }}/>
						<Typography variant="body2">{evolutionDiff || 0}%</Typography>
					</Box>
				</TooltipSeeker>
			</Grid>
		)}
		{!onlyPrice && (
			<Grid item xs={6} sx={{ display: "flex", alignItems: "center", justifyContent: "center", visibility: !prevPrice ? 'hidden' : ''  }}>
				<TooltipSeeker title="Previous Price">
					<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
						<PriceDisplay value={prevPrice || 0} color="text.secondary"/>
					</Box>
				</TooltipSeeker>
			</Grid>
		)}
	</Grid>
}
